export function trackEvent(data) {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: 'navClick',
    ...data
  })
}
